import { Component, inject } from '@angular/core';
import { WoodCertificationDetailService } from '../proxy/geographic/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WoodCertificationDetailCreateDto,
  WoodCertificationDetailDto,
  WoodCertificationDetailExcelDownloadDto,
  WoodCertificationDetailUpdateDto,
} from '../proxy/geographic/dtos/wood-certification-detail';
import { WOODCERTIFICATIONDETAIL_CONFIG, WOODCERTIFICATIONDETAIL_FIELDS } from './wood-certification-detail.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-wood-certification-detail',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WoodCertificationDetailService, ConfirmationService],
  templateUrl: './wood-certification-detail.html',
  styleUrl: './wood-certification-detail.scss',
})
export class WoodCertificationDetail extends BaseCrudComponent<
  WoodCertificationDetailDto,
  WoodCertificationDetailCreateDto,
  WoodCertificationDetailUpdateDto,
  WoodCertificationDetailExcelDownloadDto
> {
  service = inject(WoodCertificationDetailService);
  config = WOODCERTIFICATIONDETAIL_CONFIG;
  fields = WOODCERTIFICATIONDETAIL_FIELDS;

  protected prepareUpdateDto(data: any, selected: WoodCertificationDetailDto): WoodCertificationDetailUpdateDto {
    return {
      lastCheckDate: data.lastCheckDate,
      addedDate: data.addedDate,
      woodCertificationId: data.woodCertificationId,
      locationId: data.locationId,
      contractId: data.contractId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WoodCertificationDetail';
  }
}
